import { useState } from "react";
import toast from "react-hot-toast";
import { ModalWrapper } from "../chatbar";

export default function ShareModal({ link, onClose, phoneNumber }) {
    const [copied, setCopied] = useState(false);
    const formatPhoneForWhatsApp = (phone = "") => phone.replace(/\D+/g, "");
    const waPhone = formatPhoneForWhatsApp(phoneNumber);

    const SHARE_MESSAGE = `JOIN PHONEBOOKPLUS
Manage contacts and chat in one place—link multiple numbers to a single profile and control exactly what your network sees.`;

    const shareTextWithLink = `${SHARE_MESSAGE}\n\n${link}`;

    const apps = [
        {
            name: "WhatsApp",
            icon: "./social-media/WhatsApp.svg",
            url: waPhone
                ? `https://wa.me/${waPhone}?text=${encodeURIComponent(shareTextWithLink)}`
                : `https://wa.me/?text=${encodeURIComponent(shareTextWithLink)}`
        },
        {
            name: "Telegram",
            icon: "./social-media/Telegram.svg",
            url: `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(SHARE_MESSAGE)}`
        }
    ];

    const handleShare = async (app) => {
        if (app.url) {
            window.open(app.url, '_blank');
        } else {
            await navigator.clipboard.writeText(link);
            toast.success("Link copied! Paste it into the app.");
        }
    };

    const handleCopyContent = async () => {
        try {
            await navigator.clipboard.writeText(shareTextWithLink);
            setCopied(true);
            toast.success("Invitation copied to clipboard");
            window.setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error("Could not copy invitation");
        }
    };

    //     const shareViaWebAPI = async (link) => {
    //     if (navigator.share) {
    //         try {
    //             await navigator.share({
    //                 title: "Invitation",
    //                 text: "Join me using this link:",
    //                 url: link,
    //             });
    //             return true;   // Sharing success, no fallback needed
    //         } catch (err) {
    //             //             return false;
    //         }
    //     }
    //     return false; // Web Share API not supported
    // };

    return (
        <ModalWrapper onClose={onClose}>
            <p className="text-lg font-semibold mb-4 text-center">Share Invitation</p>
            {/* <div className="grid grid-cols-4 gap-4"> */}
            <div className="flex justify-center gap-6">

                {apps.map((app, i) => (
                    <button
                        key={i}
                        onClick={() => handleShare(app)}
                        className="flex flex-col items-center gap-1"
                    >
                        <img className="h-10 w-10" src={app.icon} alt={app.name} />
                        <span className="text-xs">{app.name}</span>
                    </button>
                ))}

                <button
                    type="button"
                    onClick={handleCopyContent}
                    className="flex flex-col items-center gap-1"
                    title="Copy invitation message with link"
                >
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#F3F0FF] text-[#6938EF]">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                            />
                        </svg>
                    </span>
                    <span className="text-xs">{copied ? "Copied!" : "Copy"}</span>
                </button>
            </div>

            <button
                onClick={onClose}
                className="w-full mt-4 py-2 rounded-full bg-gray-200 hover:bg-gray-300"
            >
                Close
            </button>
        </ModalWrapper>
    );
}
